<template>
  <div class="balloon balloon-text" @click.shift.left.exact="bubbleShift">
    {{ message.payload }}
  </div>
</template>

<script>
export default {
  name: 'PayloadUnknown',
  props: {
    conversation: Object
  },
  data() {
    return {
      message: {},
      sender: ''
    }
  },
  watch: {
    conversation: {
      immediate: true,
      handler() {
        this.message = this.conversation.message
        this.sender = this.conversation.sender
      }
    }
  },
  methods: {
    bubbleShift(e) {
      this.$emit('debugPopup', this.conversation)
    }
  }
}
</script>
